/**
 * Frontend logic for Press Articles block.
 * Client-side pagination - shows/hides articles without server requests.
 */

(function () {
    'use strict';

    const initPressArticles = (section) => {
        if (!section || !section.classList.contains('wp-block-ow-feature-block-press-articles')) {
            return;
        }

        const btn = section.querySelector('.wp-block-ow-feature-block-press-articles__load-more');
        const grid = section.querySelector('.press-artciles-block');

        if (!grid) {
            return;
        }

        // If no button, nothing to do
        if (!btn) {
            return;
        }

        const perPage = parseInt(section.getAttribute('data-per-page'), 10) || 12;
        const articles = Array.from(grid.querySelectorAll('.base-article-card'));

        // Remove button if all articles are already visible
        const visibleCount = articles.filter(article => article.classList.contains('visible')).length;
        if (visibleCount >= articles.length) {
            btn.remove();
            return;
        }

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const visibleArticles = articles.filter(article => article.classList.contains('visible'));
            const nextIndex = visibleArticles.length;
            const nextBatch = articles.slice(nextIndex, nextIndex + perPage);

            // Show next batch
            nextBatch.forEach(article => {
                article.classList.add('visible');
            });

            // Check if all articles are now visible
            const allVisible = articles.every(article => article.classList.contains('visible'));
            if (allVisible) {
                btn.style.display = 'none';
            }
        });
    };

    // Initialize function that works both on DOMContentLoaded and immediately
    const initialize = () => {
        document.querySelectorAll('.wp-block-ow-feature-block-press-articles').forEach((section) => {
            initPressArticles(section);
        });
    };

    // Run immediately if DOM is ready, otherwise wait for DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        // DOM is already loaded
        initialize();
    }
})();


